export const displaySeatIds = (selectedSeats) => {
  return selectedSeats
    .sort((a, b) => (a.row === b.row ? a.seat - b.seat : a.row.localeCompare(b.row)))
    .map((seat) => seat.id)
    .join(', ')
}
